<template>
  <div
    id="loader"
    class="page-loader">
    <div class="loading-circle"/>
  </div>
</template>

<script>
export default {
  name: 'LoaderLayout',
};
</script>
